import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

interface IPropsTableTr {
    id?: number | undefined
    customClass?: string | undefined
}

export default /*#__PURE__*/_defineComponent({
  props: {
    id: { type: [Number, null], required: false, default: undefined },
    customClass: { type: [String, null], required: false, default: undefined }
  },
  setup(__props: any) {

const props = __props as { id: number | undefined, customClass: string | undefined }


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("tr", {
    class: _normalizeClass(["block border border-gray-stroke rounded-2xl py-4 lg:py-0 mb-2 lg:mb-0 lg:rounded-none lg:border-0 lg:table-row", {
            [props.customClass || 'bg-white']: isFinite(props.id),
            'lg:bg-gray-stroke': isFinite(props.id) && props.id % 2 !== 0,
            'lg:bg-gray-bg': isFinite(props.id) && props.id % 2 === 0,
        }])
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})